import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import * as _ from 'underscore';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { MAP_CONSTANTS, CONSTANTS } from '../../../analytics/constants/analytics.constants';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { MapComponentService, MapLegendItem } from '../map/map.component.service';
import { MapComponent } from '../map/map.component';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';

@Component({
	selector: 'app-map-v5-beta',
	templateUrl: './map-v5-beta.component.html',
	styleUrls: ['./map-v5-beta.component.css'],
	providers: [MapComponentService]
})
export class MapV5BetaComponent extends MapComponent implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@Input() uniqueoverwriteid: string;
	public popup: any;
	protected mapStyle = 'mapbox://styles/freq-e-deek/cjv6zgkb9aqn21fpaujnfz8go';
	protected miniMapStyle = 'mapbox://styles/freq-e-deek/cjv6zgkb9aqn21fpaujnfz8go';
	protected mapFillColor = 'rgba(31, 119, 188, 0.7)';
	public enableZone: boolean = false;
	public enableZip: boolean = false;
	public colorPalette: ColorPalette;
	protected PRODUCTS: any = {
		ALL: 'all',
		DISPLAY: 'display',
		PREROLL: 'preroll'
	};

	public circleMarkerStyles = {
		'circle-color': '#1f77bc',
		'circle-radius': 5,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};

	public minimapCircleStyle = {
		'circle-color': '#cbe0ef',
		'circle-radius': 5,
		'circle-stroke-color': '#fff',
		'circle-stroke-width': 1
	};
	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 1
		},
		{
			productName: 'Video',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 2
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 3
		},
		{
			productName: 'TV Everywhere',
			productKey: MAP_CONSTANTS.STATE.SIMPLIFI_CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 4
		},
		{
			productName: 'Television',
			productKey: MAP_CONSTANTS.STATE.TELEVISION,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasTelevision'],
			order: 5
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 6
		},
		{
			productName: 'Connected TV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 7
		}
	];

	/**
	 *
	 * @type {{productName: string; productKey: string; showInLegend: boolean; show: boolean; isDisabled: boolean; isSelected: boolean}[]}
	 */
	// protected GF_PRODUCTS = [];

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
	}

	ngOnInit() {
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 20;
		// this.partnerCountryLngLat["lat"] += 1;
		this.defaultMapZoom = 2.5;
		super.ngOnInit();
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}
	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	get selectedState() {
		return this.mapComponentService.selectedState;
	}

	protected displayLocationDataOnMouseover(regionObj: any) {
		super.displayLocationDataOnMouseover(regionObj, {});
		const isTVactive = !!this.mapObj.legend.filter((item) => item.isSelected && item.productKey === 'cox_tv').length;
		const deselectedLegends = this.mapObj.legend.filter(
			(item) => !item.isSelected && !item.isDisabled && item.productKey !== 'cox_tv'
		);
		const allLegends = this.mapObj.legend.filter((item) => !item.isDisabled && item.productKey !== 'cox_tv');
		if (
			(parseInt(regionObj.sem) ||
				parseInt(regionObj.display) ||
				parseInt(regionObj.ctv) ||
				parseInt(regionObj.radio) ||
				parseInt(regionObj.preroll) ||
				parseInt(regionObj.simplifi_ctv)) &&
			deselectedLegends.length !== allLegends.length
		) {
			this.enableZip = true;
		} else {
			this.enableZip = false;
		}
		if (parseInt(regionObj.tv) && isTVactive) {
			this.enableZone = true;
		} else {
			this.enableZone = false;
		}
	}

	get geofenceCenterDetailsForMap() {
		return [
			{
				attribute: 'Impressions',
				value: this.geofenceCenterDetails ? this.formatNumber(this.geofenceCenterDetails.total_impression_sum) : ''
			},
			{
				attribute: 'CTR',
				value: this.geofenceCenterDetails ? this.geofenceCenterDetails.click_through_rate + '%' : ''
			},
			{ attribute: 'Clicks', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_click_sum : '' },
			{ attribute: 'Android', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_android + '%' : '' },
			{ attribute: 'Apple', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_ios + '%' : '' }
		];
	}
	get showLegend() {
		return (
			this.selectedState === this.PRODUCTS.ALL ||
			this.selectedState === this.PRODUCTS.DISPLAY ||
			this.selectedState === this.PRODUCTS.PREROLL
		);
	}

	formatNumber(value: { toString: () => { replace: (arg0: RegExp, arg1: string) => void } }) {
		return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
	}

	/**
	 *
	 * @param {string} mapSourceLayer
	 * @param {string} vectorMapId
	 * @param filter
	 * @param propertyToFilter
	 * @param opacity
	 */
	protected drawRegionsLayer(
		mapSourceLayer: string,
		vectorMapId: string,
		filter: any,
		propertyToFilter: any,
		opacity?: any
	) {
		if (mapSourceLayer === 'polygons') {
			this.removeMapLayer(this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': opacity
				},
				filter: filter[filter.length - 1]
			});

			this.removeMapLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': 1
				},
				filter: ['==', propertyToFilter, '']
			});

			let geo_hover_timeout;
			this.map.on('mousemove', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const gcdId =
						e && e.features && e.features[0].properties['gcd_id'] ? e.features[0].properties['gcd_id'].toString() : '';
					let regionObject = gcdId ? _.findWhere(this.selectedCombination.regionData, { gcd_id: gcdId }) : {};
					this.displayLocationDataOnMouseover(regionObject);
				}
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							e && e.feature && e.feature[0] && e.features[0].properties
								? e.features[0].properties[propertyToFilter]
								: ''
						]);
					}
				}, 10);
			});

			this.map.on('mouseleave', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, () => {
				this.hideLocationDataOnMouseout();
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							''
						]);
					}
				}, 10);
			});
		} else if (mapSourceLayer === 'points' && this.showgeofencepoints) {
			this.removeMapLayer(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.circleMarkerStyles,
				filter: filter[filter.length - 1]
			});
			this.map.setLayerZoomRange(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.removeMapLayer(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.circleMarkerStyles,
				filter: ['==', propertyToFilter, '']
			});
			this.map.setLayerZoomRange(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.map.on('mousemove', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject);
				}
			});
			this.map.on('mousemove', this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject);
				}
			});
			this.map.on('mouseleave', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				this.hideLocationDataOnMouseout();
			});
		}
	}

	protected toggleGeoFenceData(flag, product?) {
		if (!flag) {
			if (product) {
				if (product.productKey === MAP_CONSTANTS.STATE.GEOFENCE) {
					this.removeAllGeoFenceMarkers();
					this.removeGeoFenceRecencyLayer(product);
				} else if (product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO) {
					this.removeAllGeoVideoMarkers();
					this.removeGeoFenceRecencyLayer(product);
				}
			} else {
				this.removeAllGeoFenceMarkers();
				this.removeGeoFenceRecencyLayer();
				this.removeAllGeoVideoMarkers();
				this.removeGeoVideoRecencyLayer();
			}
		} else {
			if (this.showgeocenters) {
				this.drawGeoFencePoints(product);
			}
			if (this.showgeofencepoints) {
				this.drawGeoRecencyLayer(product);
			}
		}
	}
}
